import { render } from "./ParameterSegment.vue?vue&type=template&id=4b7ca880&ts=true"
import script from "./ParameterSegment.vue?vue&type=script&lang=ts"
export * from "./ParameterSegment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__